import { refreshChartCallback } from './state.js';

/**
 * Centralized refresh function that should be called after any data change
 * that affects the visualization (name changes, claims, creates, deletes, etc.)
 * 
 * This ensures the chart visualization stays in sync with the backend data.
 */
export async function refreshVisualization(): Promise<void> {
    if (refreshChartCallback) {
        await refreshChartCallback();
    }
}
